import { BASE_URL } from "./constants.js";
import { getItem } from "./cepStorage";

class Api {
  constructor({ baseUrl }) {
    this._baseUrl = baseUrl;
    const token = getItem("jwt");
    const authHeader = token ? `Bearer ${token}` : "";
    this._headers = {
      "Content-Type": "application/json",
      authorization: authHeader,
    };
  }

  _fetchWithCheck(endpoint, config = {}) {
    const token = getItem("jwt");
    const authHeader = token ? `Bearer ${token}` : "";

    return fetch(`${this._baseUrl}/${endpoint}`, {
      ...config,
      headers: {
        "Content-Type": "application/json",
        authorization: authHeader,
        ...config.headers,
      },
    }).then((response) => {
      return response.json().then((data) => {
        if (!response.ok) {
          throw new Error(data.message);
        }
        return data;
      });
    });
  }

  getScript(filename) {
    const token = getItem("jwt");
    const authHeader = token ? `Bearer ${token}` : "";

    return fetch(`${this._baseUrl}/script/${filename}`, {
      method: "GET",
      headers: {
        authorization: authHeader,
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Ошибка загрузки скрипта: ${response.status}`);
      }
      return response.text(); // <--- ВАЖНО! не .json()
    });
  }

  getOpenAi(prompt) {
    return this._fetchWithCheck("gpt", {
      method: "POST", // Убедитесь, что сервер ожидает POST-запрос
      body: JSON.stringify({ prompt }),
    });
  }

  getFontCatalog(type, version, signal) {
    const query = version ? `?version=${encodeURIComponent(version)}` : "";
    return this._fetchWithCheck(`fonts/catalog/${encodeURIComponent(type)}${query}`, {
      method: "GET",
      cache: "no-store",
      signal,
    });
  }

  getFonts(type) {
    return this._fetchWithCheck("fonts", {
      method: "POST",
      body: JSON.stringify({ type }),
    });
  }

  getFootages(mediaArray) {
    return this._fetchWithCheck("footages", {
      method: "POST",
      body: JSON.stringify(mediaArray),
    });
  }

  createUser({ name, family, login, email, password }) {
    return this._fetchWithCheck("signup", {
      method: "POST",
      body: JSON.stringify({ name, family, login, email, password }),
    });
  }

  login({ email, password }) {
    return this._fetchWithCheck("signin", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
  }

  getUserInfo() {
    return this._fetchWithCheck("users/me");
  }

  updateSubscription(userId, data) {
    return this._fetchWithCheck(`users/${userId}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    });
  }

  getButtons() {
    return this._fetchWithCheck("ppbuttons");
  }
}

const mainApi = new Api({
  baseUrl: BASE_URL,
});

export default mainApi;
